import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function Problems() {
  const problems = ['Descontrol en la rotación y ausentismo del personal de guardia.', 'Riesgo constante de multas por vencimiento de matrículas y habilitaciones.', 'Pérdida de tiempo valioso armando planillas de turnos manualmente.', 'Estrés extremo ante cada auditoría o inspección del Ministerio de Salud.', 'Falta de comunicación clara y protocolos de ingreso (onboarding) para nuevos médicos y enfermeros.'];
  return <section className="py-12 px-4 text-white" data-id="element-139">
      <div className="max-w-lg mx-auto" data-id="element-140">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 leading-tight" data-id="element-141">
          En las clínicas y hospitales, es{' '}
          <span className="text-red-400" data-id="element-142">muy difícil</span> mantener el orden
        </h2>

        <div className="space-y-4" data-id="element-143">
          {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700" data-id="element-144">
              <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-145" />
              <p className="text-slate-200 font-medium leading-relaxed" data-id="element-146">
                {problem}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}